import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Base from "../../base/views/base";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from '@material-ui/core/CardHeader';
import TextField from "@material-ui/core/TextField";
import CssBaseline from "@material-ui/core/CssBaseline";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import {  getStoreProfileDetails } from "../helper/dashboardHelper";

import {
    getSessionData
  } from "../../base/helper/baseHelper";


const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  border:{
    border:"2px solid red"
  },
  card :{
    width : "100%",
    marginBottom : "0.5rem",
    marginTop : "0.3rem"
  },
  cardBody : {
    padding : "2rem"
  }
}));

export default function MyStore() {
  const classes = useStyles();
  const userData = JSON.parse(getSessionData({ key: "userData" }))
  const storeData = JSON.parse(getSessionData({ key: "store" }))
  const [pharmacyData, setState] = useState({
    pharmacyName: "",
    pharmacyPlan: "",
    pharmacyOwner: "",
    pharmacyAddress: "",
  });

  useEffect(() => {
    var storeId = storeData.storeid;
    getStoreProfileDetails(storeId).then((res) => {
      setState({
        ...pharmacyData,
        pharmacyName: res.data[0].pharmacy_name,
        pharmacyPlan: res.data[0].pharmacy_plan,
        pharmacyOwner: res.data[0].pharmacy_owner,
        pharmacyAddress: res.data[0].pharmacy_address
      });
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Base showBaseMenu={false} hideDrawer={true} hidePharmacyButton={true}>
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <Container maxWidth="md" className={classes.Appcss}>
            <div className={classes.paper}>
              <Typography component="h1" variant="h5">
                Pharmacy Profile
              </Typography>
              <Card className={classes.card}>
                <CardHeader title="Login Details" style={{backgroundColor: "#f5f5f5"}}/>
                <Grid container spacing={3} className={classes.cardBody} >
                  <Grid item xs={4}>
                    <TextField
                      required
                      value={userData && userData.userid ? userData.userid : ""}
                      autoComplete="uid"
                      name="userId"
                      variant="outlined"
                      fullWidth
                      id="userId"
                      label="User Name"
                      autoFocus
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      required
                      value={userData && userData.rolename ? userData.rolename : ""}
                      autoComplete="uid"
                      name="userRole"
                      variant="outlined"
                      fullWidth
                      id="userRole"
                      label="User Role"
                      autoFocus
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      required
                      value={userData && userData.lastlogin ? userData.lastlogin : ""}
                      autoComplete="uid"
                      name="lastLogin"
                      variant="outlined"
                      fullWidth
                      id="lastLogin"
                      label="Last Login"
                      disabled
                    />
                  </Grid>
                </Grid>
              </Card>
              <Card className={classes.card}>
                <CardHeader title={"Pharmacy - "+ pharmacyData.pharmacyName} style={{backgroundColor: "#f5f5f5"}}/>
                <div className={classes.form}>
                <Grid container spacing={3} className={classes.cardBody}>
                  <Grid item xs={6}>
                    <TextField
                      required
                      value={pharmacyData.pharmacyName}
                      autoComplete="uid"
                      name="pharmacyName"
                      variant="outlined"
                      fullWidth
                      id="pharmacyName"
                      label="Pharmacy Name"
                      autoFocus
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                        required
                        value={pharmacyData.pharmacyPlan}
                        autoComplete="uid"
                        name="pharmacyPlan"
                        variant="outlined"
                        fullWidth
                        id="pharmacyPlan"
                        label="Pharmacy Plan"
                        autoFocus
                        disabled
                      />
                  </Grid>
                  <Grid item xs={6}>
                     <TextField
                        required
                        value={pharmacyData.pharmacyOwner}
                        autoComplete="uid"
                        name="pharmacyOwner"
                        variant="outlined"
                        fullWidth
                        id="pharmacyOwner"
                        label="Pharmacy Owner"
                        autoFocus
                        disabled
                      />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      id="pharmacyAddress"
                      label="Pharmacy Address"
                      autoComplete="uid"
                      variant="outlined"
                      multiline
                      disabled
                      fullWidth
                      value={pharmacyData.pharmacyAddress}
                    />
                  </Grid>
                </Grid>
              </div>
              </Card>
            </div>
          </Container>
          <LandingPageFooter />
        </Container>
      </Base>
    </>
  );
}
